import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { User } from '../../shared/models/user.interface';
import { finalize } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { Role } from '../../shared/models/role.interface';
import { RolePermissions } from '../../shared/models/rolePermissions.interface';
import { Permissions } from '../../shared/models/permissions.interface';
import { Office } from '../../shared/models/office.interface';
import { AdminService } from '../../admin/services/admin.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../../admin/models/generic.dialog.interface';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { RolePermission } from '../../shared/models/role.permission.enum';
import { RoleModule } from '../../shared/models/role.module.enum';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class UserEditComponent extends AbstractBiditComponent implements OnInit {
  user: User;
  roles: Role[];
  selectedRoleId: number = null;
  rolePermissions: RolePermissions[];
  offices: Office[];
  loggedInUser: User;

  quoteOnly: boolean;
  userPermissions: number[];
  biditUser = true;

  
  constructor(deviceDetectorService: DeviceDetectorService,
    private userService: UserService, private adminService: AdminService,
    public userDialogRef: MatDialogRef<UserEditComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) {
    super(deviceDetectorService);
  }

  ngOnInit() {
    let dealerId = this.userService.getDealerId();
    let userId = this.data.id;

    if (userId == null) {

      this.userService.getUser('newUser')
        .subscribe({
          next: (data) => {
            this.user = data;
            this.user.isActive = true;
            this.user.calendarView = 'Week';
          }
        });
    }
    else {
      this.userService.getUser(userId)
        .subscribe({
          next: (data) => {
            this.user = data;
            if (data.role_ID != null) {
              this.assignRolePermissions();
            }
          },
          error: (error: string) => this.onError(error)
        });
    }

    this.adminService.getAvailableRoles(dealerId)
      .subscribe({
        next: (data) => {
          this.roles = data;
        }
      });

    this.adminService.getAvailableOffices(dealerId)
      .subscribe({
        next: (data) => {
          this.offices = data;
        }
      });

    this.quoteOnly = AdminService._authUserSource.value.isQuoteOnly;
  }

  saveUser(form: NgForm) {
    console.log('in user onSubmit: ', this.user);
    this.errors = '';

    if (form.valid) {
      this.isRequesting = true;
      let dealerId = this.adminService.getDealerId();
      this.user.dealer_ID = dealerId;

      this.userService.saveUser(this.user)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe(
          {
            next: (result) => {
              console.log(result);
              this.userDialogRef.close();
            },
            error: (error: string) => this.onError(error)
          });
    }
  }

  displayRole(rolePerm: RolePermissions): boolean {
    if (!this.quoteOnly) return true;

    switch (rolePerm.module_ID) {
      case RoleModule.Jobs:
        return false;
      default:
        return true;
    }
  }

  displayPerm(permission: Permissions): boolean {
    if (!this.quoteOnly) return true;

    switch (permission.perm_ID) {
      case RolePermission.FieldTechnician:
        return false;
      default:
        return true;
    }
  }

  onRoleSelectionChange() {
    this.assignRolePermissions();
  }

  assignRolePermissions() {
    this.biditUser = true;

    if (this.user.role_ID.toString() == '') {
      this.rolePermissions = [];
      return;
    }

    this.adminService.getRolePermissions(this.user.role_ID)
      .subscribe({
        next: (data) => {
          this.rolePermissions = data;

          let roleType = this.rolePermissions.find(rp => rp.module_ID == 13);
          this.biditUser = roleType?.permissions.find(p => p.isSelected && p.perm_ID == RolePermission.Salesperson_NonBIDIT) == undefined;
        }
      });
  }

  onNoClick(): void {
    this.userDialogRef.close();
  }
}
